import React, { useState } from "react";
import classes from "./Home.module.css";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { Drawer, useMediaQuery } from "@mui/material";

const Home = () => {
  const isMobile = useMediaQuery("(max-width:1024px)");
  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  return (
    <div className={`flex-row ${classes.main_container}`}>
      {!isMobile && <Sidebar />}
      <Drawer
        anchor="left"
        open={openDrawer}
        onClose={toggleDrawer}
        PaperProps={{
          sx: { width: "250px", backgroundColor: "#1d5fa4" },
        }}
      >
        <Sidebar onClose={toggleDrawer} isMobile={isMobile} />
      </Drawer>
      <div className={`flex-col ${classes.right_content}`}>
        <Navbar onMenuClick={toggleDrawer} isMobile={isMobile} />
        <div className="ht-100 bg-base pd-24 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Home;
